import React, { useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Accordion } from 'semantic-ui-react';
import styled from 'styled-components';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';

const StyledAccordionTitle = styled(Accordion.Title)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
`;

const ScrollableContainer = styled.div`
  height: 150px;
  overflow-x: hidden;
`;

const ErrorMessage = ({meta: {submitError}, ...restProps}: FieldRenderProps) => {

  let message = <div/>;

  const [active, toggleAccordion] = useState(false);

  if (submitError != undefined) {
    if (Array.isArray(submitError)) {
      message = (
          <StyledErrorMessage {...restProps}>
            {
              submitError.map((error: string, index: number) => (
                  <div key={index}>
                    {error}
                  </div>
              ))
            }
          </StyledErrorMessage>
      )
    } else if (typeof submitError == "string") {
      message = (
          <StyledErrorMessage {...restProps}>
            {submitError}
          </StyledErrorMessage>
      )
    } else {
      message = (
          <StyledErrorMessage {...restProps}>
            <Accordion fluid>
              <StyledAccordionTitle
                  active={active}
                  index={0}
                  onClick={() => toggleAccordion(!active)}
              >
                <Icon name='dropdown'/>{submitError.errorHeader}
              </StyledAccordionTitle>
              <Accordion.Content active={active}>
                <ScrollableContainer>
                  {Array.isArray(submitError.errorContent)
                      ? submitError.errorContent.map((error: string, index: number) => (
                          <div key={index}>
                            {error}
                          </div>
                      ))
                      : submitError.errorContent
                  }
                </ScrollableContainer>
              </Accordion.Content>
            </Accordion>
          </StyledErrorMessage>
      )
    }
  }

  return message;
};

export default ErrorMessage;
